<div class="chat-window rows overflow-hidden full-height">
  @if(chatService.messagesLoading()) {
    <div class="loader flex-center">
      <mat-spinner diameter="48" strokeWidth="3" color="accent"></mat-spinner>
    </div>
  }
    <div #messageContainer class="chat-messages-container rows overflow-auto chat">
        <fyxt-chat-message
          *ngIf="!!chatService.greetingMessage"
          [message]="{text: chatService.greetingMessage, sender: MessageType.MACHINE, id: 'greeting'}"
          [ngClass]="{'message': true, 'greeting-message': true}"
        ></fyxt-chat-message>
        <fyxt-chat-message
          *ngFor="let message of (messagesOldestFirst$ | async); let i = index; trackBy: trackMessage"
          [message]="message"
          [ngClass]="{'message': message.sender === MessageType.MACHINE}"
        ></fyxt-chat-message>
    </div>
    <fyxt-send-message />
</div>
